module.exports = __webpack_public_path__ + "images/emoji/small_blue_diamond.75ba81d46f10921226e0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/small_blue_diamond.png
// module id = OMGp
// module chunks = 1